import {
  DownOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Avatar, Button, Dropdown, Layout, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import LocalizedText from '../components/LocalizedText';
import { useLocale } from '../hooks/useLocale';
import { getRoleLabel } from '../utils/roles';
import HeaderNotifications from './HeaderNotifications';

const { Header } = Layout;

export default function AppHeader({
  collapsed = false,
  onToggleSidebar,
  notificationItems = [],
  notificationMessages = [],
  notificationsLoading = false,
  onMarkAllNotificationsRead,
  markAllNotificationsLoading = false,
}) {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const { locale, toggleLocale } = useLocale();

  const menuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('common.logout'),
      onClick: logout,
    },
  ];

  const MenuIcon = collapsed ? MenuUnfoldOutlined : MenuFoldOutlined;

  return (
    <Header className="app-header">
      <div className="app-header__context">
        {onToggleSidebar && (
          <Button
            type="text"
            className="app-header__menu"
            icon={<MenuIcon />}
            onClick={onToggleSidebar}
            aria-label={t('common.toggleSidebar')}
          />
        )}
        <Typography.Text type="secondary">{t('app.subtitle')}</Typography.Text>
      </div>
      <Space size={10}>
        <HeaderNotifications
          items={notificationItems}
          messages={notificationMessages}
          loading={notificationsLoading}
          onMarkAllRead={onMarkAllNotificationsRead}
          markAllLoading={markAllNotificationsLoading}
        />
        <Button className="app-header__language" size="small" onClick={toggleLocale}>
          {locale === 'ar' ? 'EN' : 'ع'}
        </Button>
        <Dropdown menu={{ items: menuItems }} placement="bottomRight" trigger={['click']}>
          <Space className="app-header__profile">
            <Avatar size={32}>{user?.fullName?.ar?.[0] || user?.fullName?.en?.[0] || 'م'}</Avatar>
            <span className="app-header__profile-meta">
              <span className="app-header__profile-name">
                <LocalizedText value={user?.fullName} />
              </span>
              <span className="app-header__profile-role">
                {user?.roleLabel
                  ? <LocalizedText value={user.roleLabel} />
                  : getRoleLabel(user?.role, t, locale)}
              </span>
            </span>
            <DownOutlined className="app-header__profile-arrow" />
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
}
